import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { EnumJourneyAction, getJourneyAction } from '../../../../utils/enum/journeyAction';
import { RootState } from '../../../../store';
import { Dialog, DialogTitle } from '../styled';
import { formatTitleByJourneyStatus } from '../utis';
import { EScheduleSteps, updateScheduleSteps } from '../../../../features/schedule/schedule-slice';
import ScheduleAppointment from './ScheduleAppointment';
import RescheduleAppointment from './RescheduleAppointment';
import RescheduleExam from './RescheduleExam';
import ScheduleReturn from './ScheduleReturn';
import { clearCalendarSelected } from '../../../../features/calendar/calendar-slice';
import { getCurrentSchedule } from '../../JourneyActionManager';
import { ISchedules } from '../../../../services/journey.service';
import RescheduleReturnAppointment from './RescheduleReturnAppointment';

interface IConfirmation {
  open: boolean;
}
const Confirmation = ({ open }: IConfirmation) => {
  const {
    calendar: { journey, schedule }
  } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const status = getJourneyAction(journey);
  const currentSchedule = schedule ? schedule : (getCurrentSchedule(journey) as ISchedules);
  return (
    <Dialog open={open}>
      <DialogTitle>
        <CloseIcon
          onClick={() => {
            dispatch(updateScheduleSteps({ currentStep: EScheduleSteps.idle, previousStep: EScheduleSteps.idle }));
            dispatch(clearCalendarSelected());
          }}
          sx={{ cursor: 'pointer', mb: 3 }}
        />
        <Typography variant="h3" sx={{ mb: 2 }}>
          {formatTitleByJourneyStatus(journey)}
        </Typography>
      </DialogTitle>

      {status === EnumJourneyAction.AWAITING_SCHEDULE && <ScheduleAppointment />}

      {currentSchedule.returnSchedule && <RescheduleReturnAppointment />}

      {(status === EnumJourneyAction.AWAITING_CONSULTATION || status === EnumJourneyAction.VIDEOCALL_AVAILABLE) &&
        currentSchedule.returnSchedule === false && <RescheduleAppointment />}

      {status === EnumJourneyAction.AWAITING_EXAM && <RescheduleExam />}

      {status === EnumJourneyAction.AWAITING_SCHEDULE_RETURN && <ScheduleReturn />}
    </Dialog>
  );
};

export default Confirmation;
